// extracted by mini-css-extract-plugin
module.exports = {"authorLink":"_1Ouqr","itemLink":"_3BYg_","root":"_1hJLq","info":"_2dd40","author":"_33KG-","linkArea":"znWai","rating":"_25ZdQ"};